<script>
  import { onMount } from 'svelte';
  import { showPercentValue, showIntValue, makeWebsiteRequest } from '../Common/tools';
  import Tag from '../Common/Tag.svelte';
  import ListPicker from '../Popups/ListPicker.svelte';
  import { External, M } from '../external';
	import Loader from "../Common/Loader.svelte";

  export let contact;

  let data;
  let groups = [];
  let loading = true;

  function reload() {
    if (false && groups.length > 0) { // no longer loading marketing history
      External.Tools.makeWebsiteRequest({
        action: 'marketingContactHistory',
        data: {
          email: contact.email
        },
        onOk: function (response) {
          if (response && response.data) {
            data = response.data;
          }
        }
      });
    } else {
      External.Tools.makeWebsiteRequest({
        action: 'getContactLists',
        data: {
          id: contact.id
        },
        onOk: function (response) {
          if (response.data == null) {
            return;
          }
          data = { lists: response.data };
        }
      });
    }
  }

  function loadMore() {
    External.Tools.makeWebsiteRequest({
      action: 'marketingContactHistory',
      data: {
        email: contact.email,
        token: JSON.stringify(data.nextToken)
      },
      onOk: function (response) {
        if (!response || !response.data || !response.data.history) {
          return;
        }

        data.nextToken = response.data.nextToken;
        updateGroups(response.data.history);
      }
    });
  }

  let addToGroup = function (id, item) {
    for (let group in groups) {
      if (groups.hasOwnProperty(group) && groups[group].date === id) {
        groups[group].items.push(item);
        return;
      }
    }

    groups.push({ date: id, items: [item] });
  };

  let updateGroups = function (history) {
    for (let row in history) {
      if (history.hasOwnProperty(row)) {
        let date = External.Tools.dateToString(new Date(history[row].timestamp), false, false, true);
        addToGroup(date, history[row]);
      }
    }
    groups = Object.assign([], groups, []);
  };

  onMount(async () => {
    loading = true;

	data = (await makeWebsiteRequest({
	  action: 'marketingContactHistory',
	  data: {
		email: contact.email
	  }
	})).data;

	if (data) {
	  updateGroups(data.history);
	  loading = false;
	} else {
	  let response = await makeWebsiteRequest({
		action: 'getContactLists',
		data: {
		  id: contact.id
		}
	  });

	  loading = false;
	  if (response.data == null) {
		return;
	  }
	  data = { lists: response.data };
	}
  });

  function onDelete(item) {
    External.Tools.prompt(M.DELETE, M.REMOVE_CONTACT_LIST, function () {
      External.Tools.makeWebsiteRequest({
        action: 'removeContactFromList',
        data: {
          listId: item.id,
          contactId: contact.id
        },
        onOk: function () {
          reload();
        }
      });
    });
  }

  function onCreate() {
    const buttons = [
      External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup, context) {
        let formData = component.get();
        External.Tools.makeWebsiteRequest({
          action: 'addContactIdToList',
          data: {
            listId: formData.list,
            contactId: contact.id
          },
          onOk: function () {
            reload();
            popup.close();
          }
        });
      }),
      External.Button.MIDDLE_CLOSE
    ];

    let component;
    External.Tools.showWindow({
      isModal: false,
      title: M.ADD_CONTACT_TO_LIST,
      width: 500,
      buttons: buttons,
      markup: '<div class="popup-widget-wrapper"></div>',
      action: {
        onShow: function (popup, context) {
          component = new ListPicker({
            target: context.find('.popup-widget-wrapper')[0],
            props: {
              data: {},
              showNewListButton: true
            }
          });
        },
        onHide: function () {
          if (component && component.$destroy) {
            component.$destroy();
          }
          component = null;
        }
      }
    });
  }
</script>

{#if loading}
	<Loader compact={true}/>
{:else}
  <div class:none={loading} class="marketing-user-stats">
    <div class="flex col20 f-left mb-25 store-section-analytics-warapper" style="background: #f5f6fa;">
      <div class="analytics-box analytics-box-small">
        <h3>{M.TOTAL_EMAILS_SENT}</h3>
        <h2 class="col20 f-left f-28 gray-text"><b>{showIntValue(data, 'send')}</b></h2>
      </div>
      <div class="analytics-box analytics-box-small">
        <h3>{M.OPENED_EMAILS}</h3>
        <h2 class="col20 f-left f-28 gray-text">
          <b>{showPercentValue(data, 'openRate')} <span class="increase">({showIntValue(data, 'open')})</span></b>
        </h2>
      </div>
      <div class="analytics-box analytics-box-small">
        <h3>{M.CLICKED_IN_EMAIL}</h3>
        <h2 class="col20 f-left f-28 gray-text">
          <b>
            {showPercentValue(data, 'clickRate')}
            <span class="increase">
              ({showIntValue(data, 'click')})
            </span>
          </b>
        </h2>
      </div>
    </div>

    <div class="col20 f-left mb-25">
      <div class="col20 f-left mb-15 flex align-center">
        <h3 class="roboto title-line">{M.LISTS}</h3>
        <a
          on:click={onCreate}
          class="small-button blue with-icon rounded-effect"
          style="display: inline-block;margin-right: 10px">
          {M.ADD_LIST}
        </a>
      </div>
      <div class="user-lists-wrapper f-left col20">
        <div>
          {#if data && data.lists.length > 0}
            {#each data.lists as tag (tag)}
              <Tag data={tag} onClick={onDelete} />
            {/each}
          {/if}
        </div>
      </div>
    </div>
    <div class="col20 f-left mb-15 mt-15 none">
      <div class="col20 f-left marketing-date-wrapper none">
        <span class="date-title flex align-center system-bg-color">
          <span class="material-icons"> autorenew </span><span>{M.AUTOMATION_FLOWS}</span>
        </span>
      </div>
    </div>
  </div>
  <div class="col20 f-left mb-15 mt-15 none">
    <div class="col20 f-left marketing-even-wrapper">
      <div>
        <span class="event-name">Automation Flow Name - Oct 21, 2020</span> - currently on <b>Step 5</b>
      </div>
    </div>
    <div class="col20 f-left marketing-even-wrapper completed">
      <div class="flex align-center">
        <span class="event-name">Automation Flow Name - Oct 21, 2020</span>
        <span class="material-icons-outlined mr-5 ml-5"> emoji_events </span>
        - currently on &nbsp;<b>Completed (Goal Reached)</b>
      </div>
    </div>
    <div class="col20 f-left marketing-even-wrapper completed">
      <div class="flex align-center">
        <span class="event-name">Automation Flow Name - Oct 21, 2020</span> - currently on &nbsp;<b>Completed</b>
      </div>
    </div>
  </div>
	<!--
  {#if groups}
    {#each groups as group (group)}
      <div class="col20 f-left mt-15 marketing-date-wrapper">
        <span class="date-title">{group.date}</span>
      </div>
      {#each group.items as row (row)}
        <div class="col20 f-left marketing-even-wrapper">
          {#if row.event === 'open'}
            <div>
              <span class="event-name"
                >{External.Tools.timeToString(
                  new Date(row.timestamp),
                  External.WebsiteSettings.getDateFormat() === 'uk'
                )}</span>
              {contact.email}
              <span class="event-name ml-6"><b>{M.OPENED}</b></span>
              {#if row.type === 'CAMPAIGN'}
                <a class="underline" href="/me/crm/marketing/campaign/overview?id={row.id}" rel="tab"
                  >{M.CAMPAIGN_EMAIL}</a>
              {:else if row.type === 'AUTOMATION'}
                <a class="underline" href="/me/crm/marketing/automation?id={row.id}&tab=flow" rel="tab"
                  >{M.AUTOMATION_EMAIL}</a>
              {:else if row.type === 'INDIVIDUAL'}
                {M.INDIVIDUAL_EMAIL}
              {:else if row.type === 'INDIVIDUAL_SCHEDULED'}
                {M.SCHEDULED_EMAIL}
              {/if}
              ({#if row.name}{row.name}{/if}{#if row.name && row.subject}&nbsp;&ndash;&nbsp;{/if}{#if row.subject}{row.subject}{/if})
            </div>
          {:else if row.event === 'send'}
            <div>
              <span class="event-name"
                >{External.Tools.timeToString(
                  new Date(row.timestamp),
                  External.WebsiteSettings.getDateFormat() === 'uk'
                )}</span>
              {#if row.type === 'CAMPAIGN'}
                <a class="underline" href="/me/crm/marketing/campaign/overview?id={row.id}" rel="tab"
                  >{M.CAMPAIGN_EMAIL}</a>
              {:else if row.type === 'AUTOMATION'}
                <a class="underline" href="/me/crm/marketing/automation?id={row.id}&tab=flow" rel="tab"
                  >{M.AUTOMATION_EMAIL}</a>
              {:else if row.type === 'INDIVIDUAL'}
                {M.INDIVIDUAL_EMAIL}
              {:else if row.type === 'INDIVIDUAL_SCHEDULED'}
                {M.SCHEDULED_EMAIL}
              {/if}
              ({#if row.name}{row.name}{/if}{#if row.name && row.subject}&nbsp;&ndash;&nbsp;{/if}{#if row.subject}{row.subject}{/if})
              <span class="event-name ml-6"><b>{M.WAS_SENT}</b></span>
              {M.TO_RECEIVER}
              {contact.email}
            </div>
          {/if}
        </div>
      {/each}
    {/each}
  {/if}
  {#if data != null && data.nextToken != null}
    <a on:click={loadMore} class="border-button circle-effect transition-bg f-left">{M.LOAD_MORE}</a>
  {/if}
  -->
{/if}
